import '../../common/css/style.css';

// • Договори, згоди та інші документи студії
// • Самі файли документів буде додано пізніше, поки показуємо заглушки

const DOCUMENTS = [
  'Договір про надання послуг',
  'Правила відвідування студії',
  'Політика конфіденційності',
  'Згода на обробку персональних даних',
];

export const Documents = () => {
  return (
    <div id="documents" className="main-style">
      <div className="container-wrapper">
        <section className="container">
          <h2 className="container-title">Документи 📄</h2>

          <div className="documents-grid">
            {DOCUMENTS.map((title) => (
              <div className="document-card" key={title}>
                <span className="document-icon">📄</span>
                <h3 className="document-title">{title}</h3>
                <p className="document-status">
                  документ буде додано найближчим часом
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};
